var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading71_container"},[_c('div',{attrs:{"id":"container"}},[_c('label',{staticClass:"loading-title"},[_vm._v("Loading ...")]),_c('span',{staticClass:"loading-circle sp1"},[_c('span',{staticClass:"loading-circle sp2"},[_c('span',{staticClass:"loading-circle sp3"})])])])])
}]

export { render, staticRenderFns }